@if (vm$ | async; as vm) {
  <ion-row>
    <ion-col [size]="showLanguageSelector ? 7 : 8">
      @if (mainPage) {
        <p class="main-page-title">{{ pageTitle }}</p>
      }
      @if (noInternetPage) {
        @if (onLine$ | async; as onLine) {
          @if (onLine && !mainPage) {
            <div class="back-button-header">
              <ion-icon class="back-button"
                        name="chevron-back"
                        (click)="emitGoBackEvent()" />
              <span class="back-label"
                    (click)="emitGoBackEvent()">{{ pageTitle }}</span>
            </div>
          }
        }
      } @else {
        @if (!mainPage) {
          <div class="back-button-header">
            <ion-icon class="back-button"
                      name="chevron-back"
                      (click)="emitGoBackEvent()" />
            <span class="back-label"
                  (click)="emitGoBackEvent()">{{ pageTitle }}</span>
          </div>
        }
      }
    </ion-col>
    @if (displayInsightsIcon) {
      <ion-col size="1"
               class="icons">
        <ion-icon class="icon-insights"
                  src="assets/icon/icon-insights.svg"
                  (click)="openInsightsModal()" />
      </ion-col>
    }
    <ion-col size="1"
             class="icons">
      @if (authenticatedContext) {
        <app-notification-count />
      }
    </ion-col>
    <ion-col size="2"
             class="icons">
      @if (authenticatedContext) {
        <app-change-company [disabled]="companySelectorDisabled" />
      }
    </ion-col>
    @if (showLanguageSelector) {
      <ion-col id="language-trigger"
              size="2"
              class="icons"
              (click)="isLanguageListPopoverOpen$.next(true)">
        <span class="language-selector">{{ vm.currentLanguage | uppercase }}</span>
        <ion-icon name="globe-outline"
                  class="icon-language" />
      </ion-col>
    }
    @if (showLanguageSelector) {
      <ion-popover trigger="language-trigger"
                   [isOpen]="vm.isLanguageListPopoverOpen"
                   (ionPopoverDidDismiss)="isLanguageListPopoverOpen$.next(false)">
        <ng-template>
          <ion-content>
            <app-language-list [availableLanguages]="vm.availableLanguages"
                               [currentLanguage]="vm.currentLanguage"
                               (changeCurrentLanguage)="changeCurrentLanguage($event)" />
          </ion-content>
        </ng-template>
      </ion-popover>
    }
  </ion-row>
}